import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18next before rendering
import App from './App';
import { AppErrorBoundary } from './components/layout/AppErrorBoundary';
import { installChunkReloadHandler } from './lib/chunkReload';

// Sentry removed (was a third-party PHI-egress on any browser error) — the
// error boundary now catches render failures locally and shows the fallback.

// Self-heal failed dynamic-import (lazy chunk) loads after a deploy: a tab open
// across a deploy references purged chunk hashes; a one-shot guarded reload pulls
// the fresh index.html. See lib/chunkReload.ts. Frontend-only; never loops.
installChunkReloadHandler();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Lightweight error boundary fallback — intentionally plain (no branding
// assets) so it renders even if the app's CSS has failed to load.
function AppErrorFallback() {
  return (
    <div style={{ padding: 32, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
      <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
      <p style={{ marginBottom: 16 }}>
        Our team has been notified. Please refresh the page — if the problem persists,
        contact <a href="mailto:support@mskinsight.com">support@mskinsight.com</a>.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: '8px 16px', borderRadius: 6, border: '1px solid #0f172a', background: '#0f172a', color: '#fff', cursor: 'pointer' }}
      >
        Refresh
      </button>
    </div>
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary fallback={<AppErrorFallback />}>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
